import { render, staticRenderFns } from "./teamImages.vue?vue&type=template&id=20b93907&"
import script from "./teamImages.vue?vue&type=script&lang=js&"
export * from "./teamImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports